import e from"styled-components";import{TypographyTokens as o}from"@vds-tokens/typography";import{Fonts as t}from"@vds-core/typography";const i=t.VerizonNHGeTX,n=o.fontsize.body[12].value,a=o.lineheight.body[16].value,r=e.li.withConfig({displayName:"PaginationListItem",componentId:"VDS__sc-ruawv6-0"})`
  font-family: ${i};
  font-size: ${n}; // TODO: Viewport awareness?
  line-height: ${a};
  margin-${({marginSide:e})=>e}: auto;
  text-align: center;
`;export{r as default};
